import { useNavigate } from "@tanstack/react-router"
import type { FC } from "react"
import { useCallback } from "react"

import { EquivalentProductGroupsFilter } from "./EquivalentProductGroupsFilter"

import { SearchFilterDrawer } from "@/components/common/SearchFilterDrawer/SearchFilterDrawer"

interface EquivalentProductGroupsFilterDrawerProps {
  isOpen: boolean
  onToggle: () => void
}

export const EquivalentProductGroupsFilterDrawer: FC<EquivalentProductGroupsFilterDrawerProps> = ({
  isOpen,
  onToggle,
}) => {
  const navigate = useNavigate({ from: "/app/admin/manage-products/equivalents" })

  const handleClearFilters = useCallback(() => {
    navigate({
      search: (prev) => ({
        ...prev,
        equivalentTypes: undefined,
        productStatuses: undefined,
        associationTypes: undefined,
      }),
      replace: true,
    })
  }, [navigate])

  return (
    <SearchFilterDrawer toggleDrawer={onToggle} open={isOpen} clear={handleClearFilters} width={380}>
      <EquivalentProductGroupsFilter />
    </SearchFilterDrawer>
  )
}
